"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingDayComposition = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const structural_organisms_1 = require("../structural-organisms");
const styled_components_1 = __importDefault(require("styled-components"));
const with_collapse_1 = require("../../molecules/with-collapse");
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const SportActivities_1 = require("./SportActivities");
const Trainings_1 = require("./Trainings");
const TrainingDayComposition = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(List, { children: [props.header, props.trainingItemsData.length ? ((0, jsx_runtime_1.jsx)(TrainingWithCollapse, { header: (0, jsx_runtime_1.jsx)(Header, { children: t("training.overview.title") }, void 0), body: (0, jsx_runtime_1.jsx)(Trainings_1.Trainings, { trainingItemsData: props.trainingItemsData }, void 0) }, "trainings")) : ((0, jsx_runtime_1.jsx)(NoItems, { children: t("training.noTrainingDay") }, void 0)), props.sportActivities.length ? ((0, jsx_runtime_1.jsx)(SportActivitiesWithCollapse, { header: (0, jsx_runtime_1.jsx)(Header, { children: t("training.activity") }, void 0), body: (0, jsx_runtime_1.jsx)(SportActivities_1.SportActivities, { sportActivities: props.sportActivities }, void 0) }, "activities")) : ((0, jsx_runtime_1.jsx)(NoItems, { children: t("training.noActivities") }, void 0))] }, void 0));
};
exports.TrainingDayComposition = TrainingDayComposition;
const WithCollapse = (0, styled_components_1.default)(with_collapse_1.WithCollapse) `
  & > div:last-of-type {
    padding: 0;
    & > div {
      border: none;
    }

    & > div:not(:first-of-type) {
      border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
    }
  }
`;
const TrainingWithCollapse = (0, styled_components_1.default)(WithCollapse) `
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:last-of-type {
      padding: 0 !important;

      & > div:last-of-type > div:last-of-type {
        border-bottom: none;
      }
    }
  }
`;
const SportActivitiesWithCollapse = (0, styled_components_1.default)(WithCollapse) `
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div:last-of-type {
      padding: 0 !important;
    }
  }
`;
const List = (0, styled_components_1.default)(structural_organisms_1.ListWithMargin) `
  margin-bottom: ${({ theme }) => theme.spacings.xl};

  & > div:not(:first-of-type) > div:last-of-type {
    padding: ${({ theme }) => `0 ${theme.spacings.m} ${theme.spacings.m}`};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    margin-bottom: 0;
  }
`;
const Header = (0, styled_components_1.default)(typography_1.H4) `
  font-weight: 600;
`;
const NoItems = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  font-weight: 600;
  line-height: 1.5rem;
  padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    padding: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=TrainingDayComposition.js.map